/**
 * 処理後物品目
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/after_disposal_items`

const search_after_disposal_item = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 処理後物リスト
     * @param context
     * @param param1
     * @param param1.after_type { String } after_industrial: 廃棄物, after_recycling: 再資源化物
     * @param param1.large_category { Boolean } 大分類のみ
     * @param param1.parent_id { Number } 大分類ID
     * @return {Promise<unknown>}
     */
    index (context, { after_type, large_category, parent_id } = {}) {
      const params = {
        after_type,
        large_category,
        parent_id,
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params }).then(data => {
          resolve(data.content)
        })
      })
    },
    show (context, { id } = {}) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH+'/'+id, ).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default search_after_disposal_item
